module.exports = "<app-header></app-header>\n<main>\n\t<router-outlet></router-outlet>\n</main>\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = 1